import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@verantos-dev/app-state-base';

export const selectCohortDefinitionState = (state: RootState) => state.cohortDefinitionStaging;

export const selectCohortProfileIsLoading = createSelector(
  selectCohortDefinitionState,
  (state) => state?.isLoading
);

export const selectCohortDefinitionError = createSelector(
  selectCohortDefinitionState,
  (state) => state?.error
);

export const selectCohortDefinitionIsVersionLoading = createSelector(
  selectCohortDefinitionState,
  (state) => state?.isVersionLoading
);

export const selectCohortDefinitionVersionError = createSelector(
  selectCohortDefinitionState,
  (state) => state?.versionError
);

export const selectCohortDefinitionIsEditable = createSelector(
  selectCohortDefinitionState,
  (state) => state?.isEditable
);
export const selectCohortDefinitionIsStagedFromResearchAssistant = createSelector(
  selectCohortDefinitionState,
  (state) => state?.isStagedFromResearchAssistant
);

export const selectCohortDefinitionIsStagedFromUserEdit = createSelector(
  selectCohortDefinitionState,
  (state) => state?.isStagedFromUserEdit
);

export const selectCohortDefinitionInputFieldConfigMap = createSelector(
  selectCohortDefinitionState,
  (state) => state?.inputFieldConfigMap
);

export const selectCohortDefinitionLegacy = createSelector(
  selectCohortDefinitionState,
  (state) => state?.cohortDefinitionLegacy
);

export const selectCohortDefinitionSimpleEvents = createSelector(
  selectCohortDefinitionLegacy,
  (state) => state?.simpleEvents
);

export const selectCohortDefinitionSimpleEventById = (eventId: string) =>
  createSelector(selectCohortDefinitionSimpleEvents, (state) =>
    state?.find((event) => event.id === eventId)
  );

export const selectCohortDefinitionDerivedEvents = createSelector(
  selectCohortDefinitionLegacy,
  (state) => state?.derivedEvents
);

export const selectCohortDefinitionDerivedEventById = (eventId: string) =>
  createSelector(selectCohortDefinitionDerivedEvents, (state) =>
    state?.find((event) => event.id === eventId)
  );

export const selectCohortDefinitionSubjectVariables = createSelector(
  selectCohortDefinitionLegacy,
  (state) => state?.subjectVariables
);

export const selectCohortDefinitionSubjectVariableById = (variableId: string) =>
  createSelector(selectCohortDefinitionSubjectVariables, (state) =>
    state?.find((variable) => variable.id === variableId)
  );

export const selectCohortDefinitionStudyPeriodRestrictions = createSelector(
  selectCohortDefinitionLegacy,
  (state) => state?.studyPeriodRestrictions
);

export const selectCohortDefinitionIndexDate = createSelector(
  selectCohortDefinitionLegacy,
  (state) => state?.indexDate
);

export const selectCohortDefinitionItemById = (id: string) =>
  createSelector(selectCohortDefinitionLegacy, (state) => {
    return (
      state?.simpleEvents.find((event) => event.id === id) ||
      state?.derivedEvents.find((event) => event.id === id) ||
      state?.subjectVariables.find((variable) => variable.id === id)
    );
  });
